import {AfterContentInit, ContentChildren, Directive, Input, OnDestroy} from '@angular/core';
import {NgForm, NgModel} from '@angular/forms';

/**
 * Template-driven forms only collect NgModel controls that live in the same
 * component view as the <form>. Controls declared inside a child component are
 * not automatically registered with the parent NgForm (the child view cannot
 * reach the parent form's ControlContainer). As a result form.invalid is always
 * false for such forms and submit-time validation never triggers.
 *
 * Place this directive on a wrapper element inside the child component and pass
 * the parent NgForm via [parentForm]. It registers every named projected NgModel
 * with that NgForm so validation (and markAllAsTouched) works.
 */
@Directive({
  selector: '[appFormRegistration]'
})
export class FormRegistrationDirective implements AfterContentInit, OnDestroy {
  @Input() parentForm?: NgForm;

  @ContentChildren(NgModel, {descendants: true}) private models?: unknown;

  ngAfterContentInit(): void {
    this.register();
  }

  ngOnDestroy(): void {
    const form = this.parentForm;
    if (!form || !this.models) {
      return;
    }
    for (const model of this.models as Iterable<NgModel>) {
      if (model.name) {
        form.removeControl(model);
      }
    }
  }

  private register(): void {
    const form = this.parentForm;
    if (!form || !this.models) {
      return;
    }
    for (const model of this.models as Iterable<NgModel>) {
      if (model.name) {
        form.addControl(model);
      }
    }
  }
}
